var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import { Box, Stack, Typography, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import useCustomerPortalPermissions from "../../hooks/useCustomerPortalPermissions";
import CommonHeader from "../../components/UtilityComponents/commonHeader";
import { DocumentManagementIcon } from "../../components/icons";
import { CustomSwitch } from "../../components/uiComponents/CustomSwitch";
import { api_service } from "../../api/api_service";
import { api_urls } from "../../api/api_urls";
import { utility } from "../../utils";
import constants from "../../config/constants";
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from "../../components/UtilityComponents/ConfirmationAndInformationPoup";
import { colors } from "../../Themes/colors";
var CustomerPortalDocumentTypeAccess = function () {
    var documentTypeAccess = useCustomerPortalPermissions().documentTypeAccess;
    var location = useLocation();
    var _a = useState([]), documentTypes = _a[0], setDocumentTypes = _a[1];
    var _b = useState(false), dataUnavailable = _b[0], setDataUnavailable = _b[1];
    var _c = useState(false), confirmationOpen = _c[0], setConfirmationOpen = _c[1];
    var _d = useState(null), pendingUpdate = _d[0], setPendingUpdate = _d[1];
    var transformDocumentData = function (apiDocs) {
        return apiDocs.map(function (doc) { return ({
            id: doc.Id,
            name: doc.Description || doc.DocCode,
            extensions: "PDF, XLS",
            maxSize: "15 MB",
            enabled: doc.IsAccessible === 1,
            docCode: doc.DocCode,
            description: doc.Description,
        }); });
    };
    var fetchDocumentTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiResponse, transformedData, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.CUSTOMER_PORTAL_DOCUMENTS_LIST,
                            payLoad: {},
                            showLoader: true,
                        })];
                case 1:
                    response = _b.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        apiResponse = response.data;
                        transformedData = transformDocumentData((_a = apiResponse.data) !== null && _a !== void 0 ? _a : []);
                        setDocumentTypes(transformedData);
                        setDataUnavailable(false);
                    }
                    else {
                        setDataUnavailable(true);
                    }
                    return [3, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error("[DocumentTypeAccess] Error fetching document types:", error_1);
                    setDataUnavailable(true);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var updateDocumentAccess = function (code, status) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_2, errorMessage;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    payload = {
                        code: code,
                        status: status,
                    };
                    return [4, api_service.patch({
                            endPoint: api_urls.CUSTOMER_PORTAL_UPDATE_DOCUMENT_ACCESS,
                            payLoad: payload,
                            showLoader: true,
                        })];
                case 1:
                    response = _d.sent();
                    if ((response === null || response === void 0 ? void 0 : response.data) && response.data.statusCode === 200) {
                        utility.alert(response.data.message || "Document access updated successfully!", constants.TOAST_TYPES.INFO);
                        fetchDocumentTypes();
                        return [2, response.data];
                    }
                    else {
                        utility.alert(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message) || "Failed to update document access", constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    return [3, 3];
                case 2:
                    error_2 = _d.sent();
                    console.error("[DocumentTypeAccess] Error updating document access:", error_2);
                    errorMessage = ((_c = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ||
                        (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) ||
                        "Failed to update document access";
                    utility.alert(errorMessage, constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 3: return [2];
            }
        });
    }); };
    var handleToggle = function (id) {
        var doc = documentTypes.find(function (d) { return d.id === id; });
        if (doc) {
            var newStatus = doc.enabled ? 0 : 1;
            setPendingUpdate({ id: doc.id, docCode: doc.docCode, newStatus: newStatus });
            setConfirmationOpen(true);
        }
    };
    var handleConfirmUpdate = function () {
        if (pendingUpdate) {
            updateDocumentAccess(pendingUpdate.docCode, pendingUpdate.newStatus);
            setConfirmationOpen(false);
            setPendingUpdate(null);
        }
    };
    var handleCancelUpdate = function () {
        setConfirmationOpen(false);
        setPendingUpdate(null);
    };
    useEffect(function () {
        fetchDocumentTypes();
    }, [location.key]);
    return (React.createElement(Box, { sx: { p: 3 } },
        React.createElement(CommonHeader, { mainTitle: "Document Type Access", subTitle: "Manage document access, allowed file types, and size limits.", icon: React.createElement(Box, { sx: { "& svg": { height: 24, width: 24 }, height: 24 } },
                React.createElement(DocumentManagementIcon, null)) }),
        React.createElement(Stack, { mt: 3 }, dataUnavailable ? (React.createElement(Box, { sx: {
                py: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: colors.greyShades[15],
            } },
            React.createElement(Typography, { variant: "body1" }, "No data available."))) : (React.createElement(Grid, { container: true, spacing: 2 }, documentTypes.map(function (doc) { return (React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, key: doc.id },
            React.createElement(Box, { alignItems: "flex-start", sx: {
                    bgcolor: "#FFFFFF",
                    borderRadius: 4,
                    p: 2,
                    opacity: documentTypeAccess.canEdit ? 1 : 0.6,
                } },
                React.createElement(Typography, { variant: "subtitle1", fontWeight: 600, sx: { mb: 1 } }, doc.name),
                React.createElement(Box, { display: "flex" },
                    React.createElement(CustomSwitch, { checked: doc.enabled, onChange: function () { return handleToggle(doc.id); }, disabled: !documentTypeAccess.canEdit }),
                    React.createElement(Typography, { variant: "body1", color: colors.greyShades[15], sx: { mb: 1, ml: 1 } }, "Allow Downloads"))))); })))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, titleText: "Are you sure?", message: (pendingUpdate === null || pendingUpdate === void 0 ? void 0 : pendingUpdate.newStatus) === 1
                ? "Are you sure you want to enable access for this document type?"
                : "Are you sure you want to disable access for this document type?", acceptBtnText: "Yes", denyBtnText: "No", open: confirmationOpen, acceptCallBack: handleConfirmUpdate, denyCallBack: handleCancelUpdate, cancelCallBack: handleCancelUpdate, swapButtonOrder: true })));
};
export default CustomerPortalDocumentTypeAccess;
